import { render, staticRenderFns } from "./CandidateAttachments.vue?vue&type=template&id=0241f295&"
import script from "./CandidateAttachments.vue?vue&type=script&lang=js&"
export * from "./CandidateAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports